import { HttpService } from 'services/http';


export const getPartnerCardTiers = (queryParams: object) => HttpService.get('/v3/card-tiers', queryParams);

